export default {
      id: "Icon--locationHotspotMarker-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--locationHotspotMarker",
      toString: function () {
        return this.url;
      }
    }